var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconInputNumber = function SvgMiconInputNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M13 7h3V5h-3a4 4 0 0 0-3 1.38A4 4 0 0 0 7 5H4v2h3a2 2 0 0 1 2 2v5H5v2h4v7a2 2 0 0 1-2 2H4v2h3a4 4 0 0 0 3-1.38A4 4 0 0 0 13 27h3v-2h-3a2 2 0 0 1-2-2v-7h4v-2h-4V9a2 2 0 0 1 2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M18 25h10v2H18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M24 26V14h-2v12zm-1 1h5v-2h-5zm0-2h-5v2h5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "m23.624 14.78-5 4-1.249-1.56L21.399 14h1.6z",
    clipRule: "evenodd"
  })));
};
export default SvgMiconInputNumber;